(function () {
  // Shopify's standard money formatter (same algorithm as the money_format.js
  // snippet Shopify ships), so add-on prices render using the shop's own
  // money_format setting instead of a hardcoded currency symbol.
  function formatMoney(cents, format) {
    if (cents == null || isNaN(cents)) return '';

    function defaultOption(opt, def) {
      return opt == null || opt === '' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;

    switch (token) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return placeholderRegex.test(formatString) ? formatString.replace(placeholderRegex, value) : formatString + value;
  }

  // Pull out MacBook model identifiers (A1932, A2337, "Air 13", "Pro 14", "Neo", etc.)
  // so we can match a same-model accessory variant to whichever variant the
  // shopper currently has selected on the main product.
  function extractModelTokens(str) {
    if (!str) return [];
    var matches = str.toUpperCase().match(/A\d{3,4}|AIR\s?1[135]|PRO\s?1[346]|MACBOOK\s?12|NEO/g) || [];
    return matches.map(function (token) {
      return token.replace(/\s+/g, '');
    });
  }

  function scoreVariant(hostTokens, variantTitle) {
    var variantTokens = extractModelTokens(variantTitle);
    var score = 0;
    hostTokens.forEach(function (token) {
      if (variantTokens.indexOf(token) !== -1) score++;
    });
    return score;
  }

  function pickBestVariant(hostTitle, variants) {
    if (!variants || !variants.length) return null;
    var hostTokens = extractModelTokens(hostTitle);
    var best = variants[0];
    var bestScore = -1;

    variants.forEach(function (variant) {
      var score = scoreVariant(hostTokens, variant.title);
      if (score > bestScore) {
        bestScore = score;
        best = variant;
      }
    });

    return best;
  }

  function safeParse(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  if (customElements.get('product-addons')) return;

  customElements.define(
    'product-addons',
    class ProductAddons extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.productFormId = this.dataset.productFormId;
        this.sectionId = this.dataset.sectionId;
        this.form = this.productFormId ? document.getElementById(this.productFormId) : null;
        this.items = Array.from(this.querySelectorAll('[data-addon]'));

        var initialVariantEl = this.querySelector('[data-initial-variant]');
        this.hostVariant = safeParse(initialVariantEl && initialVariantEl.dataset.initialVariant);

        this.items.forEach(this.initItem.bind(this));
        this.updateAllMatches();
        this.bindSubmit();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(
            PUB_SUB_EVENTS.variantChange,
            function (event) {
              if (String(event.data.sectionId) !== String(this.sectionId)) return;
              this.hostVariant = event.data.variant;
              this.updateAllMatches();
            }.bind(this)
          );
        }
      }

      disconnectedCallback() {
        if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
      }

      initItem(item) {
        var toggle = item.querySelector('[data-addon-toggle]');
        if (toggle) toggle.addEventListener('change', this.updateTotal.bind(this));

        var swatches = Array.from(item.querySelectorAll('[data-swatch]'));
        swatches.forEach(
          function (swatch) {
            swatch.addEventListener(
              'click',
              function () {
                swatches.forEach(function (s) {
                  s.classList.remove('is-selected');
                });
                swatch.classList.add('is-selected');
                item.dataset.activeSwatch = swatch.dataset.swatch;
                this.updateItemMatch(item);
                this.updateTotal();
              }.bind(this)
            );
          }.bind(this)
        );
      }

      getVariantsForItem(item) {
        if (item.dataset.mode === 'keyboard-swatch') {
          var active = item.dataset.activeSwatch || 'black';
          var raw = active === 'clear' ? item.dataset.clearVariants : item.dataset.blackVariants;
          return safeParse(raw) || [];
        }
        return safeParse(item.dataset.variants) || [];
      }

      updateItemMatch(item) {
        var variants = this.getVariantsForItem(item);
        var hostTitle = (this.hostVariant && this.hostVariant.title) || '';
        var match = pickBestVariant(hostTitle, variants);
        if (!match) return;

        item.dataset.matchedVariantId = match.id;
        item.dataset.matchedPrice = match.price;

        var priceEl = item.querySelector('[data-addon-price]');
        if (priceEl) priceEl.textContent = formatMoney(match.price, this.moneyFormat);
      }

      updateAllMatches() {
        this.items.forEach(this.updateItemMatch.bind(this));
        this.updateTotal();
      }

      updateTotal() {
        if (!this.form) return;
        var submitButton = this.form.querySelector('[type="submit"]');
        var submitButtonText = submitButton && submitButton.querySelector('span');
        if (!submitButtonText) return;

        if (!this._defaultButtonText) {
          this._defaultButtonText = submitButtonText.textContent.trim();
        }

        var basePrice = Number(this.hostVariant && this.hostVariant.price) || 0;
        var total = basePrice;
        var anyChecked = false;

        this.items.forEach(function (item) {
          var toggle = item.querySelector('[data-addon-toggle]');
          if (toggle && toggle.checked) {
            anyChecked = true;
            total += Number(item.dataset.matchedPrice) || 0;
          }
        });

        submitButtonText.textContent = anyChecked
          ? this._defaultButtonText + ' · ' + formatMoney(total, this.moneyFormat)
          : this._defaultButtonText;
      }

      bindSubmit() {
        if (!this.form) return;

        this.form.addEventListener(
          'submit',
          function (evt) {
            var selected = this.items
              .map(function (item) {
                var toggle = item.querySelector('[data-addon-toggle]');
                return {
                  checked: toggle && toggle.checked,
                  variantId: item.dataset.matchedVariantId,
                };
              })
              .filter(function (entry) {
                return entry.checked && entry.variantId;
              });

            if (!selected.length) return; // nothing toggled on — let the normal single-item flow handle it

            evt.preventDefault();
            evt.stopImmediatePropagation();
            this.submitCombined(
              selected.map(function (entry) {
                return entry.variantId;
              })
            );
          }.bind(this),
          { capture: true }
        );
      }

      submitCombined(addonVariantIds) {
        var mainInput = this.form.querySelector('input[name="id"]');
        var quantityInput = this.form.querySelector('input[name="quantity"]');
        var mainVariantId = mainInput && mainInput.value;
        if (!mainVariantId) return;

        var quantity = parseInt(quantityInput && quantityInput.value, 10) || 1;

        var items = [{ id: mainVariantId, quantity: quantity }].concat(
          addonVariantIds.map(function (id) {
            return { id: id, quantity: 1 };
          })
        );

        var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = { items: items };

        if (cartEl) {
          body.sections = cartEl.getSectionsToRender().map(function (section) {
            return section.id;
          });
          body.sections_url = window.location.pathname;
        }

        var submitButton = this.form.querySelector('[type="submit"]');
        var spinner = this.form.querySelector('.loading__spinner');
        if (submitButton) {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
        }
        if (spinner) spinner.classList.remove('hidden');

        fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              console.error(response.description || response.message);
              alert(response.description || response.message || 'Something went wrong adding these items to your cart.');
              return;
            }

            if (!cartEl) {
              window.location = routes.cart_url;
              return;
            }

            cartEl.renderContents(response);

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-addons',
                cartData: response,
              });
            }
          })
          .catch(function (e) {
            console.error(e);
            alert('Network error adding these items to your cart.');
          })
          .finally(function () {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
})();
